import Fallback from "app/components/Fallback";
import React from "react";

const Permission = React.lazy(() =>
  import("app/modules/counselorPermission/pages/Permission")
);

export const PermissionPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Permission {...props} />
  </React.Suspense>
);
